import { getFromLocal } from "src/util/cache.service";
import { LOCAL_KEYS } from "src/util/util.constant";
import { usePermissionStore } from "src/store/usePermissionStore";

export type AdministrationAction = "view" | "edit" | "delete";

interface LegacyPermission {
  activityName?: string;
  name?: string;
  code?: string;
  canView?: boolean;
  canEdit?: boolean;
  canDelete?: boolean;
  enabled?: boolean;
}

const ACTION_FIELD: Record<AdministrationAction, keyof LegacyPermission> = {
  view: "canView",
  edit: "canEdit",
  delete: "canDelete",
};

export const hasAdministrationPermission = (
  action: AdministrationAction,
) => {
  const storePermissions = usePermissionStore.getState().permission;
  const localPermissions =
    getFromLocal<LegacyPermission[]>(LOCAL_KEYS.PERMISSIONS) ?? [];
  const permissions = (storePermissions.length
    ? storePermissions
    : localPermissions) as LegacyPermission[];

  if (!permissions.length) return true;

  const administrationPermission = permissions.find(
    (permission) =>
      permission.activityName === "Administration" ||
      permission.name === "Administration" ||
      permission.code === "Administration",
  );

  if (!administrationPermission) return false;
  if (
    action === "view" &&
    administrationPermission.enabled === false &&
    administrationPermission.canView === false
  ) {
    return false;
  }

  return Boolean(administrationPermission[ACTION_FIELD[action]]);
};
